import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      width: 640,
      margin: theme.spacing(8, 'auto', 0),
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    cardContainer: {
      margin: theme.spacing(0, 'auto'),
      padding: `${theme.spacing(8, 10)} !important`,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(8, 4),
      },
    },
    policy: {
      margin: theme.spacing(3, 4, 10),
      maxWidth: 560,
      textAlign: 'center',
    },
    link: {
      margin: 0,
      color: styles.palette.text.secondary,
      textDecoration: 'none',
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'underline',
      },
    },
  })
);
